<template>
<section>

	<StretchModal :showModal="showDetails" :clickToClose="false" :closeIcon="true" :width="width" :maxWidth="maxWidth" :height="height" @close="close()" ref="modal">
		<template #header>Landing Page: {{landingPage.adminLabel}}</template>
		<template #default="{ closed }">
			<LandingPageDetails v-if="landingPage" :itemIn="landingPage" :isNew="isNew" @itemAdded="item => $emit('itemAdded', item)" @itemEdited="item => $emit('itemEdited', item)" @close="closed" ref="details" />
		</template>
	</StretchModal>

	<ConfirmDialog :show="showConfirmation" :cancel="'Go Back'" :confirm="'Close Anyway'" @confirm="confirmClose()" @cancel="showConfirmation = false">
		<div>Are you sure?  <b>Unsaved changes will be lost!</b></div>
	</ConfirmDialog>

</section>
</template>



<script>
import LandingPageDetails from './LandingPageDetails.vue'
import StretchModal from '@/components/utilities/StretchModal.vue'
import ConfirmDialog from '@/components/utilities/ConfirmDialog.vue'
export default {
	name: 'LandingPageDetailsModal',

	components: {
		LandingPageDetails,
		StretchModal,
		ConfirmDialog,
	},


	props: {
		landingPage: {
			type: Object,
			default: null
		},
		isNew: {
			type: Boolean,
			default: false
		},
		width: {
			type: String,
			default: '90%'
		},
		maxWidth: {
			type: String,
			default: null
		},
		height: {
			type: String,
			default: '100%'
		},
	},


	data() {
		return {
			showDetails: false,
			showConfirmation: false,
		}
	},



	methods: {
		open() { this.showDetails = true },

		close() {
			if(this.$refs.details.changesMade) {
				this.showConfirmation = true
				return
			}

			this.showDetails = false
			this.$emit('close')
		},

		confirmClose() {
			this.showDetails = false
			this.showConfirmation = false
			this.$emit('close')
		},

		cancelClose() {
			this.showConfirmation = false
		},

	}
}
</script>
